export const channelMessagesInitial = Object.freeze({
  list: [],
  hasBefore: false,
  hasAfter: false,
  loading: false,
});

export const searchInitial = Object.freeze({
  channelID: null,
  query: '',
  results: [],
  loading: false,
});

export default Object.freeze({
  channels: [],
  messages: {},
  loading: false,
  sending: {},
  search: searchInitial,
});
